<script setup>
import { useRoute } from 'vue-router';
import CompanyLogoBox from '../organisms/CompanyLogoBox.vue';
import { useJobDataStore } from '../../stores/job-store';
import AppIcon from '../atoms/app/AppIcon.vue';
import { useAuth } from '../../stores/auth-store';
import AppLink from '../atoms/app/AppLink.vue';
import { useBreakpoints } from '../../composables/breakpoint';
import KarriereAtLogo from '../../assets/img/logos/karriereAtLogo.svg';
import SmartBewerben from '../../assets/img/logos/smartBewerben.svg';
import { PAGE_SENDING } from '../../routes';
import WebOnly from '../webview/WebOnly.vue';

const route = useRoute();
const jobData = useJobDataStore();
const auth = useAuth();
const { isMobile } = useBreakpoints();

const emit = defineEmits(['open-login-modal']);
</script>

<template>
    <div class="border-b border-b-black border-solid">
        <div class="px-l h-[3.75rem] max-w-screen-l mx-auto flex gap-m m:gap-3xl items-center">
            <div class="flex gap-m min-w-0 items-center">
                <CompanyLogoBox
                    v-if="jobData.jobDataFetched"
                    class="w-[37px] h-[37px] m:order-last flex-shrink-0"
                    minimal-padding
                    no-border
                />
                <div class="flex flex-col m:flex-row m:items-center m:gap-s mt-[1px] overflow-hidden">
                    <SmartBewerben :class="jobData.jobDataFetched ? 'w-[6rem] m:w-[9rem]' : 'w-[9rem]'"/>
                    <template v-if="jobData.jobDataFetched">
                        <span class="hidden m:block">bei</span>
                        <span class="overflow-hidden whitespace-nowrap text-ellipsis">
                            {{ jobData.companyName }}
                        </span>
                    </template>
                </div>
            </div>
            <WebOnly
                v-if="!auth.isLoggedIn"
                class="ml-auto"
            >
                <AppLink
                    v-if="!route.matched.some(({ name }) => name === PAGE_SENDING)"
                    tag="button"
                    neutral
                    class="no-underline"
                    @click="emit('open-login-modal')"
                >
                    <AppIcon
                        v-if="isMobile"
                        name="avatar"
                        class="h-auto w-[1.25rem]"
                    />
                    <span
                        v-else
                        class="flex gap-xs py-s px-l border border-black border-solid rounded-[0.25rem]
                        hover:bg-gray-900 transition-colors items-center hover:text-white group duration-150
                        active:bg-gray-700 active:text-white font-condensed leading-[21px]"
                    >
                        Mit
                        <KarriereAtLogo
                            alt="karriere.at"
                            title="karriere.at"
                            class="h-m text-inherit group-hover:text-white duration-150"
                        />
                        anmelden
                    </span>
                </AppLink>
            </WebOnly>
        </div>
    </div>
</template>
